export const passwordValidationConfiguration = {
  minSize: 4,
  formatRegex: /^[\p{Nd}]{0,8}$/u,
};

export const usernameValidationConfiguration = {
  minSize: 3,
  maxSize: 12,
  formatRegex: /^(?=.*\p{L})[\p{L}\p{N}_]+$/u,
};

export const emailValidationConfiguration = {
  formatRegex: /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)*$/u,
};
